import { DataService } from '../../../shared/dataservice.service';
import { Component, OnInit, Input } from '@angular/core';
import { SalesOrder, SubSalesOrder, SOStatus, SSOStatus, monthFilter, PmTechnicalIP,  UiFunctionalKPI } from '../../../shared/misc-classes';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { KPIChartService } from '../../../shared/kpi-charts-service';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-planning-kpi',
  templateUrl: './planning-kpi.component.html',
  styleUrls: ['./planning-kpi.component.css']
})
export class PlanningKpiComponent implements OnInit {

  @Input() pmTechSSO: PmTechnicalIP;
  soObj: SalesOrder;
  _soObjListKpi6: Array<SalesOrder>;

  filteredSOCount: number = 0;
  filteredSSOCount: number = 0;
  isDataViewUpdated4: boolean = false;
  isLoading: boolean = false;
  PlanningKpi: Array<UiFunctionalKPI> = [];


  isManfMonthFilterSelectedKpi5: boolean = false;
  manfMonthFilterKpi5: monthFilter;

  Highcharts = Highcharts;

  totalDataPL: any;
  totalDataKpiChartOptionsPL: Highcharts.Options;
  panelWiseDataPL: any;
  panelWiseKpiChartOptionsPL: Highcharts.Options;

  
  constructor(public _dataService: DataService, public dialog: MatDialog,
    private _kpiCharServ: KPIChartService) { }

  ngOnInit() {
    try {
      this.loadSettingsFromCookies();
    } catch (e) {
      console.log(e);
    }

    this.loadData();
  }
  saveSettingsToCookies() {
    this._dataService.setCookie('s-manfmonth-sel-kpi-6', this.isManfMonthFilterSelectedKpi5 ? "1" : "0");
    if (this.isManfMonthFilterSelectedKpi5) {
      this._dataService.setCookie('s-manfmonth-val-kpi-6', this.manfMonthFilterKpi5.getCookieStr());
    }
  }
  loadSettingsFromCookies() {


    let _tmpManfMonthSel: string = this._dataService.getCookie('s-manfmonth-sel-kpi-6');
    if (_tmpManfMonthSel) {
      this.isManfMonthFilterSelectedKpi5 = (_tmpManfMonthSel == "1");

      let _tmpManfMonthVal: string = this._dataService.getCookie('s-manfmonth-val-kpi-6');
      if (_tmpManfMonthVal) {
        this.manfMonthFilterKpi5 = monthFilter.getObjFromCookieStr(_tmpManfMonthVal);
      }
    }


    let _currDate: Date = new Date();
    if (this.manfMonthFilterKpi5 == null) {
      this.manfMonthFilterKpi5 = new monthFilter(_currDate.getMonth() + 1, _currDate.getFullYear(),
        _currDate.getMonth() + 1, _currDate.getFullYear());
    }

  }
  loadData() {
    this.isLoading = true;
    this._dataService.getDataDefinitions().subscribe(res => {
      this._dataService.getAllSalesOrder(1).subscribe((_soObjAr: Array<SalesOrder>) => {
        this._soObjListKpi6 = _soObjAr.filter((_tmpSO2: SalesOrder) => {
          //test the filter.
          // if(_tmpSO2.projectStatus == SOStatus.Dispatched || _tmpSO2.projectStatus == SOStatus.Archived)
          if (_tmpSO2.projectStatus == SOStatus.Dispatched) {
            return false;
          }
          return true;
        });
        this.filterRows();
      });
    });
  }

  getClassName(_temp: number): string {
    if (_temp < 6) {
      return "bg-grey";
    } else if (_temp >= 6 && _temp < 10) {
      return "bg-yellow";
    } else if (_temp > 10) {
      return "bg-green";
    }
  }



  reloadData(): void {
    this.isLoading = true;
    this.loadData();
  }
  clearFilters(): void {

    this.isManfMonthFilterSelectedKpi5 = false;
    this.isLoading = true;
    this.loadData();

    setTimeout(() => {
      this.saveSettingsToCookies();
    }, 10);
  }



  filterRows(): void {
    this.isLoading = true;
    setTimeout(() => {
      this.filterRowsLogic2();
      this.isLoading = false;
    }, 5);
    this.saveSettingsToCookies();
  }


  private displaySOwithNoSSO() {
    if (this.isManfMonthFilterSelectedKpi5 == true

    ) {
      return false;
    }

    return true;
  }


  filterRowsLogic2() {
    let _tmpSOCounter: number = 0;
    let _tmpSSOCounter: number = 0;
    let _tmpPlanningKpi: Array<UiFunctionalKPI> = [];

    let _totalQtyPL: number = 0;
    let _delayQtyPL: number = 0;
    let _onTimeQtyPL: number = 0;
    let _delayQtyPLZS1: number = 0;
    let _onTimeQtyPLZS1: number = 0;
    let _delayQtyPLZS1DBB: number = 0;
    let _onTimeQtyPLZS1DBB: number = 0;
    let _delayQtyPLZS2: number = 0;
    let _onTimeQtyPLZS2: number = 0;
    let _delayQtyPLZS9: number = 0;
    let _onTimeQtyPLZS9: number = 0;
    let _delayQtyPLZN1: number = 0;
    let _onTimeQtyPLZN1: number = 0;

   

    let _equpList = ["001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"];

    let _showSOWithNoSSO: boolean = this.displaySOwithNoSSO();

    for (var i = 0; i < this._soObjListKpi6.length; i++) {
      let _tmpSO: SalesOrder = this._soObjListKpi6[i];

      let _isSOPassedFilter: boolean = true;
      if (_isSOPassedFilter == true) {
        let _filteredSSO: Array<SubSalesOrder> = this.getFilteredSubOrders(_tmpSO.subSalesOrder);

        if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {

          let _tmpSSOobj: UiFunctionalKPI;

          _tmpSOCounter++;

          _filteredSSO.forEach((_tmpSSO: SubSalesOrder) => {
              // Total Panel Qty  

              

            

            // Check for Pick List planned and Actual Dates      

            if (_tmpSSO.planningIP.actualPickListIssueToStoreDate != null) {
           
              let _pickListActual = _tmpSSO.planningIP.actualPickListIssueToStoreDate.getTime();
              let _isRevised = null;
              let _isRequested;
              let _pickListOtherDate;
              if(_tmpSSO.planningIP.requestedPickListIssueToStoreDate==null){
                _isRequested = false;
                _pickListOtherDate = _tmpSSO.planningIP.plannedPickListIssueToStoreDate.getTime();
                _isRevised = _tmpSSO.planningIP.plannedPickListIssueToStoreDateIsRevised;
            }
            else{
              _isRequested = true;
              _pickListOtherDate = _tmpSSO.planningIP.requestedPickListIssueToStoreDate.getTime();
            }
            _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)) {
                var temp: number = parseInt(e.panelQuantity, 10);
                if (temp > 0) {
                  _totalQtyPL += temp;
                  
                  
                }
              }
            });
              let _pickListDiff_time =  _pickListOtherDate - _pickListActual;
              let _pickListDiff = _pickListDiff_time / (1000 * 3600 * 24);
              /// Pick List Finalization Delay
              if (_pickListDiff < 0) {
              
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _delayQtyPL += temp;
                    }
                  }
                });

                let _individualDelayQtyPL = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyPLZS1 += temp;
                          _individualDelayQtyPL += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyPLZS1DBB += temp;
                          _individualDelayQtyPL += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyPLZS2 += temp;
                          _individualDelayQtyPL += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyPLZN1 += temp;
                          _individualDelayQtyPL += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyPLZS9 += temp;
                          _individualDelayQtyPL += temp;
                        }
                      }
                    });
                    break;
                }

                let _plannedTmp;
                let _revisedTmp;
                if(_isRevised!=null){
                  if(_isRevised == true){
                    _plannedTmp = null;
                    _revisedTmp = _tmpSSO.planningIP.plannedPickListIssueToStoreDate;
                  }
                  else{
                    _plannedTmp = _tmpSSO.planningIP.plannedPickListIssueToStoreDate;
                    _revisedTmp = null;
                  }
                }
                else{
                  _plannedTmp = null;
                  _revisedTmp = null;
                }
                let _requestTmp = _isRequested == false?null:_tmpSSO.planningIP.requestedPickListIssueToStoreDate;

                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'Pick List',_tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualDelayQtyPL, _plannedTmp, _revisedTmp,
                  _requestTmp, _tmpSSO.planningIP.actualPickListIssueToStoreDate, _pickListDiff, _tmpSSO.planningIP.actualPickListIssueToStoreToken.addNotes)
               
                  _tmpPlanningKpi.push(_tmpSSOobj);
              }
              // Pick List Finalization on Time
              if (_pickListDiff >= 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _onTimeQtyPL += temp;
                    }
                  }
                });

                let _individualOnTimeQtyPL = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyPLZS1 += temp;
                          _individualOnTimeQtyPL += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyPLZS1DBB += temp;
                          _individualOnTimeQtyPL += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyPLZS2 += temp;
                          _individualOnTimeQtyPL += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyPLZN1 += temp;
                          _individualOnTimeQtyPL += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyPLZS9 += temp;
                          _individualOnTimeQtyPL += temp;
                        }
                      }
                    });
                    break;
                }
                let _plannedTmp;
                let _revisedTmp;
                if(_isRevised!=null){
                  if(_isRevised == true){
                    _plannedTmp = null;
                    _revisedTmp = _tmpSSO.planningIP.plannedPickListIssueToStoreDate;
                  }
                  else{
                    _plannedTmp = _tmpSSO.planningIP.plannedPickListIssueToStoreDate;
                    _revisedTmp = null;
                  }
                }
                else{
                  _plannedTmp = null;
                  _revisedTmp = null;
                }
                let _requestTmp = _isRequested == false?null:_tmpSSO.planningIP.requestedPickListIssueToStoreDate;

                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'Pick List',_tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualOnTimeQtyPL, _plannedTmp, _revisedTmp,
                  _requestTmp, _tmpSSO.planningIP.actualPickListIssueToStoreDate, _pickListDiff, _tmpSSO.planningIP.actualPickListIssueToStoreToken.addNotes)

                  _tmpPlanningKpi.push(_tmpSSOobj);
              }


            }            

          });

        }


      }

    }

    if (_totalQtyPL != 0 || _onTimeQtyPL != 0 || _delayQtyPL != 0) {
      this.totalDataPL = [{
        "data": [{
          name: 'Total Panel Quantity',
          color: '#6e6e6e',
          y: _totalQtyPL,
        },
        {
          name: 'On Time Panel',
          color: '#6e6e6e',
          y: _onTimeQtyPL,
        },
        {
          name: 'Delayed Panel',
          color: '#6e6e6e',
          y: _delayQtyPL,
        }]
      }

      ];
    }
    else { this.totalDataPL = null; }

    this.totalDataKpiChartOptionsPL = this._kpiCharServ.getTotalDataChartOptions(this.totalDataPL);

    if (_onTimeQtyPLZN1 != 0 || _onTimeQtyPLZS9 != 0 || _onTimeQtyPLZS1 != 0 || _onTimeQtyPLZS1DBB != 0 || _onTimeQtyPLZS2 != 0
      || _delayQtyPLZN1 != 0 || _delayQtyPLZS9 != 0 || _delayQtyPLZS1 != 0 || _delayQtyPLZS1DBB != 0 || _delayQtyPLZS2 != 0) {

      this.panelWiseDataPL = [{
        name: 'On Time',
        color: '#6e6e6e',
        type: 'column',
        data: [_onTimeQtyPLZN1, _onTimeQtyPLZS9, _onTimeQtyPLZS1, _onTimeQtyPLZS1DBB, _onTimeQtyPLZS2],
      },
      {
        name: 'Delay',
        color: '#ff000f',
        type: 'column',
        data: [_delayQtyPLZN1, _delayQtyPLZS9, _delayQtyPLZS1, _delayQtyPLZS1DBB, _delayQtyPLZS2],
      }

      ];
    }
    else { this.panelWiseDataPL = null; }

    this.panelWiseKpiChartOptionsPL = this._kpiCharServ.getPanelWiseChartOptions(this.panelWiseDataPL);

    

    this.filteredSOCount = _tmpSOCounter;
    this.filteredSSOCount = _tmpSSOCounter;
    this.PlanningKpi = _tmpPlanningKpi;


    this.isDataViewUpdated4 = true;
    setTimeout(() => {
      this.isDataViewUpdated4 = false;
    }, 1000);
  }


  getManfMonthLabel(): string {
    if (this.isManfMonthFilterSelectedKpi5 == true) {
      return "Manufacturing Month : ";
    }
    else {
      return "Enable Manufacturing Month Filter";
    }
  }

  getManfFromMonthName(): string {
    if (this.manfMonthFilterKpi5) {
      return this.manfMonthFilterKpi5.fromMonthName;
    }
    return '';
  }
  getManfToMonthName(): string {
    if (this.manfMonthFilterKpi5) {
      return this.manfMonthFilterKpi5.toMonthName;
    }
    return '';
  }

  manfPrevFromMonth() {
    this.manfMonthFilterKpi5.prevFromMonth();
    this.filterRows();
  }
  manfNextFromMonth() {
    this.manfMonthFilterKpi5.nextFromMonth();
    this.filterRows();
  }
  manfPrevToMonth() {
    this.manfMonthFilterKpi5.prevToMonth();
    this.filterRows();
  }
  manfNextToMonth() {
    this.manfMonthFilterKpi5.nextToMonth();
    this.filterRows();
  }

  private getFilteredSubOrders(_ssoAr: Array<SubSalesOrder>): Array<SubSalesOrder> {
    return _ssoAr.filter((_sso: SubSalesOrder) => {
      //check for failure cases
      //dont show if sub order is dispatched
      if (_sso.isSSOStatusSet(SSOStatus.Dispatched) == true) return false;

      //check if mfg month 
      if (this.isManfMonthFilterPassed(_sso.manufacturingMonth) == false) return false;
      return true;
    });
  }


  private isManfMonthFilterPassed(_manfMonth: Date) {
    if (this.isManfMonthFilterSelectedKpi5 == true && this.manfMonthFilterKpi5 != null) {
      if (this.manfMonthFilterKpi5.isWithInFilterScope(_manfMonth) == false) {
        return false;
      }
    }
    return true;
  }

}
